/*
 * @Author: huangzq
 * @Date: 2020-04-01 23:38:29
 * @Last Modified by: huangzq
 * @Last Modified time: 2020-08-27 20:07:45
 * @Desc: 设置微信分享sdk url
*/
// 给script添加类型
// interface SCRIPTTYPE {
//   readyState?: string,
//   onreadystatechange?: any
// }

/**
 *
 * 设置微信分享sdk url
 * @param {*微信sdk js网址} sdkUrl
 * @description 手动设置微信jssdk网址，通过插入<script/>实现
 */
import CfxWxJssdk from '@cfx/wx-jssdk'
// import setJsSdkUrl from '@markting/mk-wx-sdk/build/main/setLoadWxSdk';

export default CfxWxJssdk.setLoadWxSdk
